import DOMPurify from 'dompurify'

export function sanitizeHtml(html: string, options?: DOMPurify.Config): string {
  if (!html) return ''
  return DOMPurify.sanitize(html, options) as string
}

export default sanitizeHtml
